import React from "react";
import { connect } from "react-redux";
import { Field } from "formik";
import TextArea from "../../DataEntry/TextArea";
import Box from "./Box";

class Comments extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    const {
      formik: { isSubmitting },
      viewOnly,
    } = this.props;
    return (
      <Box title="Comment(s)">
        <div className="row">
          <div className="col-xs-12 text-center" style={{ paddingTop: "10px" }}>
            <Field
              name="note"
              className="smart-form-control"
              component={TextArea}
              rows={4}
              style={{ height: "unset" }}
              disabled={viewOnly || isSubmitting}
            />
          </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (_state: any, _props: any) => ({});

const mapDispatchToProps = (_dispatch: Function) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Comments);
